<template>
  <div class="major-detail-display">
    <h4 class="section-title">4 专业详情</h4>
    
    <div v-if="selectedMajorDetail" class="detail-content">
      <div class="detail-header">
        <h5>
          <span v-if="selectedMajorDetail.rank" class="rank-badge">TOP{{ selectedMajorDetail.rank }}</span>
          {{ selectedMajorDetail.name }}
        </h5>
        <span v-if="selectedMajorDetail.score" class="match-score">{{ selectedMajorDetail.score }}/10</span>
      </div>
      
      <div class="detail-body">
        <div v-if="selectedMajorDetail.details" class="ai-analysis">
          <h6><i class="el-icon-magic-stick"></i> AI 分析详情</h6>
          
          <!-- JSON格式的结构化显示 -->
          <div v-if="selectedMajorDetail.scoreMatch" class="structured-details">
            <div class="detail-section">
              <h7><i class="el-icon-data-analysis"></i> 分数适配</h7>
              <p>{{ selectedMajorDetail.scoreMatch }}</p>
            </div>
            
            <div class="detail-section">
              <h7><i class="el-icon-star-on"></i> 兴趣匹配</h7>
              <p>{{ selectedMajorDetail.interestMatch }}</p>
            </div>
            
            <div class="detail-section">
              <h7><i class="el-icon-s-home"></i> 家庭资源</h7>
              <p>{{ selectedMajorDetail.familyMatch }}</p>
            </div>
            
            <div class="detail-section">
              <h7><i class="el-icon-trophy"></i> 专业亮点</h7>
              <p>{{ selectedMajorDetail.highlights }}</p>
            </div>
            
            <div class="detail-section">
              <h7><i class="el-icon-warning"></i> 注意事项</h7>
              <p>{{ selectedMajorDetail.concerns }}</p>
            </div>
            
            <div v-if="selectedMajorDetail.vsTop1" class="detail-section">
              <h7><i class="el-icon-sort"></i> 与TOP1对比</h7>
              <p>{{ selectedMajorDetail.vsTop1 }}</p>
            </div>
            
            <div v-if="selectedMajorDetail.whyRank3" class="detail-section">
              <h7><i class="el-icon-question"></i> 排名原因</h7>
              <p>{{ selectedMajorDetail.whyRank3 }}</p>
            </div>
          </div>
          
          <!-- 传统文本格式的显示 -->
          <div v-else class="detail-text">
            <div class="formatted-details" v-html="formatDetails(selectedMajorDetail.details)"></div>
          </div>
        </div>
        
        <div v-else-if="selectedMajorDetail.description" class="basic-info">
          <h6><i class="el-icon-info"></i> 专业信息</h6>
          <p>{{ selectedMajorDetail.description }}</p>
        </div>
        
        <div v-else class="no-detail">
          <i class="el-icon-document"></i>
          <p>暂无该专业的详细信息</p>
        </div>
      </div>
    </div>
    
    <div v-else class="empty-state">
      <i class="el-icon-s-grid"></i>
      <p>请在上方选择一个专业查看详情</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MajorDetailDisplay',
  props: {
    selectedMajorDetail: {
      type: Object,
      default: null
    }
  },
  methods: {
    formatDetails(details) {
      if (!details) return ''
      // 将 **标题**: 格式转换为 <strong>标题</strong>: 格式
      return details
        .replace(/\*\*([^*]+)\*\*:/g, '<strong>$1</strong>:')
        .replace(/\n\n/g, '<br><br>')
        .replace(/\n/g, '<br>')
    }
  }
}
</script>

<style lang="scss" scoped>
.major-detail-display {
  .section-title {
    font-size: 15px;
    font-weight: 700;
    color: #000;
    margin-bottom: 20px;
    padding-left: 0;
  }
}

.detail-content {
  background: #f8fafc;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #e2e8f0;
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e2e8f0;
  
  h5 {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #1e293b;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .rank-badge {
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
    color: white;
    padding: 2px 6px;
    border-radius: 12px;
    font-size: 10px;
    font-weight: 600;
  }
  
  .match-score {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    color: white;
    padding: 4px 10px;
    border-radius: 16px;
    font-size: 10px;
    font-weight: 600;
  }
}

.detail-body {
  h6 {
    font-size: 13px;
    font-weight: 600;
    color: #475569;
    margin: 0 0 12px 0;
    display: flex;
    align-items: center;
    
    i {
      margin-right: 6px;
      color: #3b82f6;
    }
  }
}

.ai-analysis {
  .structured-details {
    background: white;
    border-radius: 6px;
    padding: 16px;
    border-left: 4px solid #3b82f6;
    max-height: 400px;
    overflow-y: auto;
  }
  
  .detail-text {
    background: white;
    border-radius: 6px;
    padding: 16px;
    border-left: 4px solid #3b82f6;
    max-height: 300px;
    overflow-y: auto;
    
    .formatted-details {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      font-size: 13px;
      line-height: 1.6;
      color: #374151;
      margin: 0;
      white-space: pre-wrap;
      word-wrap: break-word;
      
      strong {
        font-weight: 700;
        color: #1e293b;
      }
    }
    
    pre {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      font-size: 13px;
      line-height: 1.6;
      color: #374151;
      margin: 0;
      white-space: pre-wrap;
      word-wrap: break-word;
    }
  }
}

.detail-section {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f1f5f9;
  
  &:last-child {
    margin-bottom: 0;
    border-bottom: none;
  }
  
  h7 {
    font-size: 12px;
    font-weight: 600;
    color: #475569;
    margin: 0 0 8px 0;
    display: flex;
    align-items: center;
    
    i {
      margin-right: 6px;
      color: #3b82f6;
      font-size: 14px;
    }
  }
  
  p {
    font-size: 12px;
    line-height: 1.5;
    color: #64748b;
    margin: 0;
    padding: 8px 0;
  }
}

.basic-info {
  p {
    font-size: 13px;
    line-height: 1.6;
    color: #64748b;
    margin: 0;
    padding: 12px 16px;
    background: white;
    border-radius: 6px;
    border-left: 4px solid #10b981;
  }
}

.no-detail,
.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #94a3b8;
  
  i {
    font-size: 32px;
    margin-bottom: 12px;
    display: block;
  }
  
  p {
    font-size: 13px;
    margin: 0;
  }
}

.empty-state {
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

// 滚动条样式
.detail-text::-webkit-scrollbar {
  width: 6px;
}

.detail-text::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.detail-text::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>
